import {ItemListViewProps} from "../../types/ItemListViewProps.ts";
import GridHolder from "./GridStyles.tsx";
import {useEffect} from "react";
import {loadAppropriateImages} from "../../utils/image-utils.ts";
import GetLabel from "../../language/GetLabel.tsx";

const Grid = (props: ItemListViewProps) => {

    useEffect(() => {
        loadAppropriateImages()
    }, []);

    const renderGridItems = () => {
        return props.itemList.items.map((item, i) => {
            if (item.image) {
                return (
                    <li key={`grid-item-${i}`} className="grid-item" itemProp='itemListElement'>
                        <a href={item.url}>
                            <img loading="lazy" className="multi-thumb" data-src={item.image} alt={item.altImageTxt ? item.altImageTxt : item.title} itemProp='image'/>
                        </a>
                    </li>
                )
            }
        });
    }

    return (
        <section itemScope itemType='https://schema.org/ItemList'>
            <h2 id="shows-heading" className="sr-only"><GetLabel name="PROGRAMS"/></h2>
            <GridHolder>
                {props.itemList.items &&
                    <ul className="grid-list" role="list" aria-labelledby="shows-heading">
                     {renderGridItems()}
                    </ul>
                }
            </GridHolder>
        </section>
    )
};

export default Grid;